import React from 'react';
import {CSVLink} from 'react-csv';
import { useTranslation } from 'react-i18next';
import { useInstance } from 'react-ioc';
import { ExportOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import dayjs from 'dayjs';
import { useGenerateCodesMutation } from 'generated/graphql';
import LayoutSmall from 'layouts/LayoutSmall';
import { observer } from 'mobx-react-lite';
import { Store } from 'model/store/Store';

import cls from 'pages/Domain/Domain.module.scss'

export const GenerateCodes = observer(() => {

    const {t} = useTranslation()
    const store = useInstance(Store);
    const [data, setData] = React.useState([])

    const [generateCodes, {loading}] = useGenerateCodesMutation()

    const onFinish = async () => {
        await generateCodes({
            onCompleted: (data) => {
                if (data.generateCodes?.data) {
                    setData(data.generateCodes.data);
                    store.auth.needUpdate()
                }
            }
        })
    }

    const csvHeaders = [
        { label: 'Partner', key: 'partner', },
        { label: 'Code', key: 'code', },
        { label: 'Users', key: 'users', },
        { label: 'Month', key: 'duration', },
        { label: 'Value, RUB', key: 'value', },
    ]

    return (
        <LayoutSmall title={t('Generate codes')}>
            <div className={cls.page}>
                <Button loading={loading} onClick={onFinish}>{t('Generate')}</Button>
                {data.length > 0 &&
                <CSVLink data={data} headers={csvHeaders} filename={`Saturn Codes ${dayjs().format('DD.MM.YYYY')}.csv`} separator={';'}>
                    <Button className={cls.button} ><ExportOutlined/> {t('Download')}</Button>
                </CSVLink>
                }
            </div>
        </LayoutSmall>
    )

})